import { LatLng } from "geolocation-utils";

import { api } from "api";
import { Utils } from "utils";
import { Path } from "services/path";
import { IPlace, Iterable, Prettify } from "types";

interface Props {
  start: LatLng;
  finish?: LatLng;
  places: Iterable<IPlace>[];
}

export const buildPlacesRoute = async (props: Prettify<Props>) => {
  const { start, finish, places } = props;
  const { convertToPoints, convertToLatLng } = Utils.Graphhopper;

  const waypoints = finish
    ? [undefined, ...places, undefined]
    : [undefined, ...places];

  const coordinates = finish
    ? [
        start,
        ...waypoints
          .filter(Boolean)
          .map((item) => Utils.Places.getRouteCoordinates(item!)),
        finish,
      ]
    : [
        start,
        ...waypoints
          .filter(Boolean)
          .map((item) => Utils.Places.getRouteCoordinates(item!)),
      ];

  console.log("BUILD_PLACES_ROUTE.TS", { coordinates });
  const response = await api.graphhopper.buildRoute({
    optimize: true,
    withAlternativeRoads: false,
    points: convertToPoints(coordinates),
  });

  const orderedPlaces = response.paths[0].points_order.map(
    (order) => waypoints[order]
  );

  return Promise.resolve({
    places: orderedPlaces,
    path: new Path(response.paths[0]),
    waypoints:
      response.paths[0].snapped_waypoints.coordinates.map(convertToLatLng),
  });
};

interface UpdateRequest {
  places: (Iterable<IPlace> | undefined)[];
  waypoints: LatLng[];
  avoid: string[];
  optimize?: boolean;
}

export const buildUpdatedPlacesRoute = async (
  props: Prettify<UpdateRequest>
) => {
  const { waypoints, places, avoid, optimize = false } = props;
  const { convertToPoints, convertToLatLng } = Utils.Graphhopper;

  console.log("buildUpdatedPlacesRoute", { waypoints });
  const response = await api.graphhopper.buildRoute({
    avoid,
    optimize,
    withAlternativeRoads: false,
    points: convertToPoints(waypoints),
  });

  const path = new Path(response.paths[0]);
  return Promise.resolve({
    path,
    places,
    waypoints:
      response.paths[0].snapped_waypoints.coordinates.map(convertToLatLng),
  });
};
